import { IFeatureFlagsService } from "../../services/featureFlags";
import { IPerformanceBatcher } from "./performanceProfilerInterface";
import PerformanceProfiler from "./performanceProfiler";

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class PerformanceProfilerFactory {
    static featureFlagsService: IFeatureFlagsService;
    static getInstance = (measureName: string, batcher?: IPerformanceBatcher) => {
        return new PerformanceProfiler(measureName, batcher);
    };
}